/* ==========================================================================
   BIO STEFAN | CART V2
   Zwei Custom Elements:
     <cartv2-countdown>    Versand-Cutoff. Deadline kommt als absoluter
                           Unix-Zeitstempel aus Liquid (Shop-Zeitzone),
                           daher unabhaengig von der Browser-Zeitzone.
     <cartv2-reservation>  Warenkorb-Timer. Die Deadline haengt am
                           Warenkorb-Token und liegt in localStorage,
                           springt also bei Reload/neuem Tab NICHT zurueck.

   Wichtig zur Theme-Architektur:
   component-cart.js ersetzt bei jeder Mengenaenderung das innerHTML von
   #AjaxCartForm und #AjaxCartSubtotal. Beide Elemente werden dabei neu
   erzeugt. Weil der Zustand ausserhalb des DOM liegt (Liquid-Zeitstempel
   bzw. localStorage), laufen die Timer nach dem Re-Render korrekt weiter
   statt neu zu starten.
   ========================================================================== */

(function () {
  'use strict';

  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  /* ---------------------------------------------------------------------
     1. Versand-Cutoff-Countdown
     --------------------------------------------------------------------- */
  if (!customElements.get('cartv2-countdown')) {
    customElements.define('cartv2-countdown', class extends HTMLElement {
      connectedCallback() {
        var deadline = parseInt(this.getAttribute('data-deadline'), 10);
        var serverNow = parseInt(this.getAttribute('data-now'), 10);
        if (!deadline || !serverNow) return;

        // Offset zwischen Server- und Clientuhr, damit eine falsch
        // gestellte Browseruhr den Countdown nicht verfaelscht.
        this._offset = serverNow - Math.floor(Date.now() / 1000);
        this._deadline = deadline;
        this._out = this.querySelector('[data-js-cd]') || this;

        this._tick();
        this._iv = setInterval(this._tick.bind(this), 1000);
      }

      disconnectedCallback() { clearInterval(this._iv); }

      _tick() {
        var now = Math.floor(Date.now() / 1000) + this._offset;
        var left = this._deadline - now;

        if (left <= 0) {
          clearInterval(this._iv);
          // Cutoff waehrend der Sitzung verstrichen: Zeile ausblenden statt
          // eine unwahre "heute noch"-Aussage stehen zu lassen.
          var row = this.closest('.cartv2-urgency__row');
          if (row) row.hidden = true;
          return;
        }

        var h = Math.floor(left / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;

        this._out.textContent = h > 0
          ? h + ' Std ' + pad(m) + ' Min'
          : pad(m) + ':' + pad(s) + ' Min';

        if (left < 3600) this.classList.add('is-soon');
      }
    });
  }

  /* ---------------------------------------------------------------------
     2. Warenkorb-Timer (optional, default aus)
     --------------------------------------------------------------------- */
  if (!customElements.get('cartv2-reservation')) {
    customElements.define('cartv2-reservation', class extends HTMLElement {
      connectedCallback() {
        this._minutes = parseInt(this.getAttribute('data-minutes'), 10) || 20;
        var token = this.getAttribute('data-cart-token') || 'anon';
        this._key = 'bs_cartv2_deadline_' + token;
        this._out = this.querySelector('[data-js-res]') || this;
        this._label = this.innerHTML;
        this._count = parseInt(this.getAttribute('data-item-count'), 10) || 0;

        // Shopify behaelt dasselbe cart.token, wenn der Warenkorb geleert und
        // neu befuellt wird. Ohne diesen Reset faende der Timer seine alte,
        // abgelaufene Deadline wieder und bliebe dauerhaft "abgelaufen".
        if (this._count === 0) this._clear();

        // component-cart.js feuert 'cart-updated' auf #AjaxCartForm, sobald
        // sich der Warenkorb per AJAX aendert. Darueber merken wir den
        // Uebergang leer -> gefuellt auch ohne Seitenreload.
        // Der Warenkorbzaehler im Header wird bei JEDEM Update aktualisiert,
        // egal ob per updateCartQty oder per window.refreshCart(). refreshCart
        // feuert kein 'cart-updated', deshalb reicht ein Event-Listener nicht:
        // legt man auf einer Produktseite etwas in den Warenkorb, startete der
        // Timer sonst erst nach einem Reload. Ein MutationObserver auf dem
        // Zaehler faengt alle Wege ab, auch die von Apps.
        this._onCount = function (n) {
          if (n === 0) { this._clear(); this._stop(); }
          else if (this._count === 0) { this._clear(); this._start(); }
          this._count = n;
        }.bind(this);

        var counters = document.querySelectorAll('[data-header-cart-count]');
        if (counters.length) {
          this._obs = new MutationObserver(function () {
            var n = parseInt(counters[0].textContent, 10) || 0;
            if (n !== this._count) this._onCount(n);
          }.bind(this));
          counters.forEach(function (c) {
            this._obs.observe(c, { childList: true, characterData: true, subtree: true });
          }.bind(this));
        }

        // Zusaetzlich das Theme-Event, falls der Zaehler mal fehlt.
        var form = document.getElementById('AjaxCartForm');
        if (form) {
          this._onUpdate = function () {
            var el = form.querySelector('[data-cart-count]');
            this._onCount(el ? parseInt(el.textContent, 10) || 0 : 0);
          }.bind(this);
          form.addEventListener('cart-updated', this._onUpdate);
        }

        if (this._count > 0) this._start();
      }

      disconnectedCallback() {
        this._stop();
        if (this._obs) this._obs.disconnect();
        var form = document.getElementById('AjaxCartForm');
        if (form && this._onUpdate) form.removeEventListener('cart-updated', this._onUpdate);
      }

      _clear() { try { localStorage.removeItem(this._key); } catch (e) {} }
      _stop() { clearInterval(this._iv); }

      _start() {
        this._stop();
        this.innerHTML = this._label;
        this._out = this.querySelector('[data-js-res]') || this;
        this.classList.remove('is-soon');

        var stored = null;
        try { stored = localStorage.getItem(this._key); } catch (e) { /* Private Mode */ }
        var deadline = stored ? parseInt(stored, 10) : NaN;
        if (!deadline || isNaN(deadline)) {
          deadline = Date.now() + this._minutes * 60 * 1000;
          try { localStorage.setItem(this._key, String(deadline)); } catch (e) {}
        }
        this._deadline = deadline;
        this._tick();
        this._iv = setInterval(this._tick.bind(this), 1000);
      }

      _tick() {
        var left = Math.floor((this._deadline - Date.now()) / 1000);

        if (left <= 0) {
          this._stop();
          // Der Warenkorb wird bewusst NICHT geleert.
          var expired = this.getAttribute('data-expired-text');
          this.textContent = expired && expired.trim()
            ? expired
            : (this.getAttribute('data-saved-text') || '');
          var row = this.closest('.cartv2-announce');
          if (row) row.classList.add('is-expired');
          return;
        }

        var m = Math.floor(left / 60);
        var s = left % 60;
        this._out.textContent = pad(m) + ':' + pad(s) + ' Min';
        if (left < 300) this.classList.add('is-soon');
      }
    });
  }


  /* ---------------------------------------------------------------------
     4. Add-to-Cart-Formulare im Drawer per AJAX
        Der Cross-Sell-Block ("Empfehlung von BIO Stefan") ist ein normales
        <form action="/cart/add"> ohne JS-Handler. Ein Submit laedt die Seite
        neu und Shopify leitet auf /cart um, der Kunde verliert den Drawer.
        Delegierter Listener, damit es auch nach jedem Re-Render greift.
     --------------------------------------------------------------------- */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    // Nur innerhalb des Warenkorb-Drawers abfangen, Produktseiten-Formulare
    // haben ihre eigene Logik in component-product-form.js.
    if (!form.closest('[data-js-site-cart-sidebar]')) return;

    ev.preventDefault();

    var btn = form.querySelector('[name="add"]');
    if (btn) btn.classList.add('button--loading');

    var fd = new FormData(form);
    // /cart/add.js akzeptiert form_type/utf8 nicht, das sind Felder des
    // klassischen Formular-Posts.
    fd.delete('form_type'); fd.delete('utf8');
    fd.delete('product-id'); fd.delete('section-id');

    fetch(window.KROWN && KROWN.settings.routes.cart_add_url
            ? KROWN.settings.routes.cart_add_url + '.js' : '/cart/add.js',
          { method: 'POST', headers: { 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status && data.status !== 200) throw new Error(data.description || data.message);
        // Checkboxen zuruecksetzen, sonst legt ein zweiter Klick doppelt an.
        form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
        form.querySelectorAll('input.hidden-variant-id').forEach(function (h) { h.remove(); });
        if (typeof window.refreshCart === 'function') window.refreshCart();
      })
      .catch(function (e) {
        console.warn('[cart-v2] Cross-Sell fehlgeschlagen, Fallback auf normalen Submit', e);
        form.submit();
      })
      .finally(function () { if (btn) btn.classList.remove('button--loading'); });
  }, true);

  /* ---------------------------------------------------------------------
     5. Aufraeumen: Deadlines abgelaufener/fremder Warenkoerbe entfernen,
        damit localStorage nicht endlos waechst.
     --------------------------------------------------------------------- */
  try {
    var now = Date.now();
    Object.keys(localStorage).forEach(function (k) {
      if (k.indexOf('bs_cartv2_deadline_') !== 0) return;
      var v = parseInt(localStorage.getItem(k), 10);
      if (!v || v < now - 86400000) localStorage.removeItem(k);
    });
  } catch (e) {}
})();
